import { render, staticRenderFns } from "./HomePodcasts.vue?vue&type=template&id=07868277&"
import script from "./HomePodcasts.vue?vue&type=script&lang=js&"
export * from "./HomePodcasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports